<div id="app">
    <div class="global-header-wrapper">
        <div class="global-header"></div>
    </div>
    <div class="aeg-header-wrapper" v-if="showAdminNavigation">
        <aeg-admin-header class="aeg-header-wrapper__admin-navigation" />
    </div>
    <div class="aeg-page-wrapper">
        <div class="aeg-content-block">
            <div v-if="isLoadingUserData && !allowAnonymous">
                <aeg-loader />
            </div>
            <div v-else-if="isAuthenticated || allowAnonymous">
                <aeg-application-announcements />
                <router-view mode="out-in" />
            </div>
        </div>
    </div>

    <Toast :position="'bottom-right'" />

    <div class="global-footer-wrapper">
        <div class="global-footer"></div>
    </div>
</div>
